<template>
    <div class="hidden-table">
        <div  v-if="!showTable" class="horizontal-wrapper ">
            <div class="header-wrapper">
                <slot name="header">
                    
                </slot>
            </div>
            <div class="bundle-wrapper">
                <md-button class="md-icon-button" @click="showTable = true">
                    <md-icon v-if="!showTable" :md-src="require('../../images/bars-solid.svg')"></md-icon>

                </md-button>
            </div>
        </div>

        <md-table v-else 
            v-model="tableRows" 
            :md-height="345" 
            :md-sort.sync="tableSortBy" 
            :md-sort-order.sync="tableSortOrder" 
            :md-sort-fn="customSort"
            md-card  
            md-fixed-header  
            >
             <md-table-toolbar>
                <md-button class="md-icon-button" @click="showTable = false;">
                    <md-icon :md-src="require('../../images/xmark-solid.svg')"></md-icon>
                    
                </md-button>
             </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell v-for="(c, i) in table.headers" :key="item[i] + i" :md-label="c" :md-sort-by="c">{{ item[i] }}</md-table-cell>
            </md-table-row>
        </md-table>

        <!--
        <table v-else>
            <thead>
                <tr>
                    <th v-for="(header, index) in table.headers" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in table.rows" :key="rowIndex">
                    <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>

                </tr>
            </tbody>
        </table>
        -->

        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
    name: "HiddenTable",
    props: {
        table: {
            type: Object,
            required: true,
            validator(value) {
                return (
                    Array.isArray(value.headers) &&
                    Array.isArray(value.rows) &&
                    value.rows.every(row => Array.isArray(row))
                );
            },
        },
    },
    methods:{
        customSort(value) {
            
            const sortBy = this.table.headers.findIndex(e => e == this.tableSortBy)
            

            return value.sort((a, b) => {

                if (typeof a[sortBy] == 'string' && this.tableSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy])
                } else if (typeof a[sortBy] == 'string'){
                    return b[sortBy].localeCompare(a[sortBy])
                } else if (Array.isArray(a[sortBy]) && this.tableSortOrder === 'asc'){
                    return parseFloat(a[sortBy]) - parseFloat(b[sortBy])
                } else if (Array.isArray(a[sortBy]) && this.tableSortOrder === 'desc') {
                    return  parseFloat(b[sortBy]) - parseFloat(a[sortBy])
                } else if (this.tableSortOrder === 'asc'){
                    return a[sortBy]? -1: 0;
                } else if (this.tableSortOrder === 'desc'){
                    return b[sortBy]? -1: 0;
                }


            })
        },
    },
    data(){
        //console.log(this.$props.table.rows);
        
        return{
            tableRows: this.$props.table.rows,

            showTable: false,

            tableSortBy: this.$props.table.headers[0]? this.$props.table.headers[0]: '',
            tableSortOrder: 'desc',
        }
    },
    watch:{
        "table.rows.length"(newLen, oldLen) {
            
            if (newLen !== oldLen) {
                this.tableRows = this.table.rows;
            }
    },
    }
};
</script>

<style scoped>
.hidden-table{
  flex: 1 0 0;

  border: 1pt solid var(--color5);
  background-color: var(--color1);

  border-style: solid;
  border-color: var(--color5);


}
.header-wrapper{
    margin-left: 30px;
    flex: 1 0 0;
}
.bundle-wrapper{
    flex: 0 0 30px;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th, td {
    border: 1px solid #ddd;
    padding: 8px;
}

th {
    background-color: #f4f4f4;
    text-align: left;
}
</style>